import { getClassZoomList } from "@/services/class-zoom.service";
import { formatDateEditZone } from "@/utils/utils";

import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  //Etkinlik Listesi
  async loadClassZoomList(vuexContext, co) {
    return await getClassZoomList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((item, index) => {
        item.index = index + 1;

        if (item.classDayTimeList.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        } else {
          item.classDayAndTime = "";
          item.dayAndTime = "";
        }

        item.classDayTimeList.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day?.name} ${formatDateEditZone(dayTime.startDate, item.class.timePeriod, "+03:00")} 
          - ${formatDateEditZone(dayTime.endDate, item.class.timePeriod, "+03:00")}
            `;
          if (index < item.classDayTimeList.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day?.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
            `;
          if (index < item.classDayTimeList.length - 1) {
            item.dayAndTime += " / ";
          }
        });
      });

      setPaginationDetails(co, totalCount, totalPages);

      return items;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
